export default __webpack_public_path__ + "static/media/iconly_bulk_logout.7da59e73.svg";